import React from "react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/thankYou")({
  component: React.lazy(() =>
    import("@/pages/donor-profile/sections/profile/thankYou").then((mod) => ({
      default: mod.ThankYou,
    })),
  ),
});
